
//import './App.css';
import {
    LineChart,
    ResponsiveContainer,
    Legend, Tooltip,
    Line,
    XAxis,
    YAxis,
    CartesianGrid
} from 'recharts';
import React from 'react';
  
class Graph extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user_data: null,
            bench_data: [],
            squat_data: [],
            deadlift_data: [],
            body_weight_data: []
        }
    
    }   

    async componentDidMount() {
        // First get the users discord user id for the data to plot the graph 
        const queryParams = new URLSearchParams(window.location.search);
        const user_id = queryParams.get('id')
        console.log(user_id)

        const firebase = require('firebase/app')
        const firestore = require('firebase/firestore')

        // Your web app's Firebase configuration
        // For Firebase JS SDK v7.20.0 and later, measurementId is optional
        const firebaseConfig = {
        apiKey: "AIzaSyDrtmhqEuoRjfnE1QCRdeYG6qlc7FAqIfk",
        authDomain: "gym-bro-discord-bot.firebaseapp.com",
        //databaseURL: "https://gym-bro-discord-bot-default-rtdb.firebaseio.com", // Real-time database
        projectId: "gym-bro-discord-bot"
        //storageBucket: "gym-bro-discord-bot.appspot.com",
        //messagingSenderId: "199430379675",
        //appId: "1:199430379675:web:406bf36a6f4496ef450e3e",
        //measurementId: "G-S9G1V79BPR"
        };
        // Initialize the Firebase app
        const app = firebase.initializeApp(firebaseConfig);
        // Connect to the Firestore Database 
        const db = firestore.getFirestore();

        const user_doc_ref = firestore.doc(db, "users", user_id);
        
        const get_doc = await firestore.getDoc(user_doc_ref);
        const user_data = get_doc.data()
        this.setState( {user_data: user_data} )
        console.log(user_data)

        // Get the bench history 
        let bench_history = this.state.user_data.stat_data.bench.history
        // Chart data
        let bench_graph_data = [];
        for (const [key, val] of Object.entries(bench_history)) {
            
            let cur_dict = {
                name: key,
                weight: val 
            }
            bench_graph_data.push(cur_dict)
        }

        bench_graph_data.sort((a, b) => new Date(b.name) - new Date(a.name));
        bench_graph_data = bench_graph_data.reverse()
        this.setState( {bench_data: bench_graph_data} );
        console.log(this.state.bench_data)

        // Get the squat history 
        let squat_history = this.state.user_data.stat_data.squat.history
        // Chart data
        let squat_graph_data = [];
        for (const [key, val] of Object.entries(squat_history)) {
            
            let cur_dict = {
                name: key,
                weight: val 
            }
            squat_graph_data.push(cur_dict)
        }

        squat_graph_data.sort((a, b) => new Date(b.name) - new Date(a.name));
        squat_graph_data = squat_graph_data.reverse()
        this.setState( {squat_data: squat_graph_data} );
        console.log(this.state.squat_data);

        // Get the deadlift history 
        let deadlift_history = this.state.user_data.stat_data.deadlift.history;
        // Chart data
        let deadlift_graph_data = [];
        for (const [key, val] of Object.entries(deadlift_history)) {
            
            let cur_dict = {
                name: key,
                weight: val 
            }
            deadlift_graph_data.push(cur_dict)
        }

        deadlift_graph_data.sort((a, b) => new Date(b.name) - new Date(a.name));
        deadlift_graph_data = deadlift_graph_data.reverse()
        this.setState( {deadlift_data: deadlift_graph_data} );
        console.log(this.state.deadlift_data)

        // Get the body_weight history 
        //let body_weight_history = this.state.user_data.stat_data.weight_history;
        // Chart data
        let body_weight_graph_data = [];
        for (const [key, val] of Object.entries(this.state.user_data.stat_data.weight_history)) {
            //console.log(key)
            let cur_dict = {
                name: key,
                weight: val 
            }
            //this.setState( { body_weight_data: [...this.state.body_weight_data, cur_dict] } );
            body_weight_graph_data.push(cur_dict)
        }
        
        //this.setState( {body_weight_data: body_weight_graph_data} );
        body_weight_graph_data.sort((a, b) => new Date(b.name) - new Date(a.name));
        body_weight_graph_data = body_weight_graph_data.reverse()
        this.setState( {body_weight_data: body_weight_graph_data} )
        console.log(this.state.body_weight_data);

    }


    render() {
        if (this.state.user_data == null || this.state.bench_data == null || this.state.squat_data == null 
            || this.state.deadlift_data == null || this.state.body_weight_data == null) {
            return(<h1>Loading...</h1>)
        }

        else {
            return (
                <>

                    <h1 className="text-heading">
                        {this.state.user_data.discord_user_data.username}#{this.state.user_data.discord_user_data.discriminator} History
                    </h1>
                    <h3>Dates are recorded from the date you log them using the Gym Bro Bot</h3>

                    <br></br>
                    <h2>Bench History:</h2>
                    <ResponsiveContainer width="100%" aspect={3}>
                        <LineChart data={this.state.bench_data} margin={{ right: 300 }}>
                            <CartesianGrid />
                            <XAxis dataKey="name" 
                                interval={'preserveStartEnd'} />
                            <YAxis></YAxis>
                            <Legend />
                            <Tooltip />
                            <Line dataKey="weight"
                                stroke="black" activeDot={{ r: 8 }} />
                        </LineChart>
                    </ResponsiveContainer>

                    <br></br>
                    <h2>Squat History:</h2>
                    <ResponsiveContainer width="100%" aspect={3}>
                        <LineChart data={this.state.squat_data} margin={{ right: 300 }}>
                            <CartesianGrid />
                            <XAxis dataKey="name" 
                                interval={'preserveStartEnd'} />
                            <YAxis></YAxis>
                            <Legend />
                            <Tooltip />
                            <Line dataKey="weight"
                                stroke="black" activeDot={{ r: 8 }} />
                        </LineChart>
                    </ResponsiveContainer>

                    <br></br>
                    <h2>Deadlift History:</h2>
                    <ResponsiveContainer width="100%" aspect={3}>
                        <LineChart data={this.state.deadlift_data} margin={{ right: 300 }}>
                            <CartesianGrid />
                            <XAxis dataKey="name" 
                                interval={'preserveStartEnd'} />
                            <YAxis></YAxis>
                            <Legend />
                            <Tooltip />
                            <Line dataKey="weight"
                                stroke="black" activeDot={{ r: 8 }} />
                        </LineChart>
                    </ResponsiveContainer>

                    <br></br>
                    <h2>Body Weight History:</h2>
                    <ResponsiveContainer width="100%" aspect={3}>
                        <LineChart data={this.state.body_weight_data} margin={{ right: 300 }}>
                            <CartesianGrid />
                            <XAxis dataKey="name" 
                                interval={'preserveStartEnd'} />
                            <YAxis></YAxis>
                            <Legend />
                            <Tooltip />
                            <Line dataKey="weight"
                                stroke="black" activeDot={{ r: 8 }} />
                        </LineChart>
                    </ResponsiveContainer>

                </>
            );  
        }
    }

}

export default Graph;